import type { Components } from "react-markdown";

export const summaryMarkdownComponents: Components = {
  h1: ({ ...props }) => <h1 className="mb-2 text-base font-bold" {...props} />,
  h2: ({ ...props }) => <h2 className="mb-2 text-sm font-semibold" {...props} />,
  h3: ({ ...props }) => <h3 className="mb-1 text-sm font-semibold" {...props} />,
  p: ({ ...props }) => <p className="mb-2 text-sm leading-relaxed last:mb-0" {...props} />,
  ul: ({ ...props }) => <ul className="mb-2 list-inside list-disc pl-2" {...props} />,
  ol: ({ ...props }) => <ol className="mb-2 list-inside list-decimal pl-2" {...props} />,
  li: ({ ...props }) => <li className="mb-1 text-sm" {...props} />,
  strong: ({ ...props }) => <strong className="font-semibold" {...props} />,
  em: ({ ...props }) => <em className="italic" {...props} />,
};
